const helperKeys = [
  'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
  'ArrowLeft', 'ArrowRight', 'Home', 'End'
]

function keydownHandler(e) {
  if (helperKeys.includes(e.key) || (e.ctrlKey || e.metaKey)) return

  if (e.key === '.') {
    if (e.target.value.includes('.')) {
      e.preventDefault()
    }
    return
  }

  if (!/^[0-9]$/.test(e.key)) {
    e.preventDefault()
  }
}

function pasteHandler(e) {
  const pastedText = e.clipboardData.getData('text')

  const input = e.target
  const start = input.selectionStart
  const end = input.selectionEnd

  const newValue =
    input.value.slice(0, start) +
    pastedText +
    input.value.slice(end)

  if (!/^\d*\.?\d*$/.test(newValue)) {
    e.preventDefault()
  }
}

export default {
  mounted(el) {
    el.addEventListener('keydown', keydownHandler)
    el.addEventListener('paste', pasteHandler)
  },

  unmounted(el) {
    el.removeEventListener('keydown', keydownHandler)
    el.removeEventListener('paste', pasteHandler)
  }
}